var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"mx-auto",attrs:{"cols":"12","sm":"8","md":"6"}},[_c('v-btn',{attrs:{"block":""}},[_vm._v("Create Quiz")]),_c('v-card-title',{staticClass:"pl-0"},[_vm._v("My Quizzes")]),_c('quiz-card'),_c('quiz-card'),_c('quiz-card'),_c('quiz-card'),_c('quiz-card'),_c('quiz-card')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }